import { MIN_CLIP_MS } from './constants';

// LightMetrics only records a clip that lies inside ONE of its own trips, and those do not match the ignition
// trips of the unit (an ignition-on can belong to a short trip that ends when the vehicle starts moving).
// Each trail event carries the id of its LightMetrics trip, so the window is cut into runs of the same id.

const length = (run) => run.end - run.start;

// Runs of the window, `{ id, start, end }` in ms. The first run is taken to start at the window start and events
// without an id stay in the current run. With no ids at all the whole window is one run (no restriction).
export const buildLmTripRuns = (events, window) => {
  const runs = [];
  let current = null;
  (events || []).forEach((event) => {
    if (!event.lmTripId) return;
    if (event.timeMs < window.start || event.timeMs > window.end) return;
    if (!current) {
      current = { id: event.lmTripId, start: window.start, end: window.end };
      runs.push(current);
      return;
    }
    if (event.lmTripId !== current.id) {
      current.end = event.timeMs;
      current = { id: event.lmTripId, start: event.timeMs, end: window.end };
      runs.push(current);
    }
  });
  if (runs.length === 0) return [{ id: null, start: window.start, end: window.end }];
  return runs;
};

export const findRunAt = (runs, ms) => runs.find((run) => ms >= run.start && ms < run.end) || null;

// The run the clip belongs to: the one holding its start when it can fit a minimum clip, else the first that can.
export const pickActiveRun = (runs, range) => {
  const holder = findRunAt(runs, range.start);
  if (holder && length(holder) >= MIN_CLIP_MS) return holder;
  const roomy = runs.find((run) => length(run) >= MIN_CLIP_MS);
  if (roomy) return roomy;
  return holder || runs.reduce((best, run) => (length(run) > length(best) ? run : best), runs[0]);
};

// The range moved inside the run, keeping its length when possible (at least a minimum clip, at most the run).
export const fitRangeInside = (range, run) => {
  const runLength = length(run);
  const wanted = range.end - range.start;
  const size = Math.min(Math.max(wanted, Math.min(MIN_CLIP_MS, runLength)), runLength);
  const start = Math.min(Math.max(range.start, run.start), run.end - size);
  return { start, end: start + size };
};
